<template>
    <div class="page-title-header">
        <h1 class="light">{{ title }}</h1>
    </div>
</template>

<script>


export default {
    name: 'PageTitle',
    props : ['title']
 
}
</script>

<style scoped>

    .page-title-header {
        background: url('./../../assets/header-contact.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
        display:flex;                
        margin-top: 43px;
        height: 400px;
        align-items: center;
        justify-content: center;
    }

    .page-title-header h1 {
        color:#1a1a23;
        font-size:30px;
        padding-top:150px;
        letter-spacing: 10px;
        text-transform: uppercase;
    }
    
    @media screen and (max-width: 767px) {
        .page-title-header {
            margin-top: 120px;
            height: 200px;
        }

        .page-title-header h1 {
            padding-top:60px;
        }
    }
</style>